import s from '../styles/pages/main.module.scss'
import BitrixUserSelector from "../elements/inputs/BitrixUserSelector";
import SubmitButton from "../elements/inputs/SubmitButton";
import InlineNotification from "../elements/InlineNotification";
import Header from "../elements/Header";
import {useCallback, useEffect, useMemo, useState} from "react";
import Loading from "../elements/Loading";
import getAPIClient from "../hooks/apiClient";
import {ReactComponent as CallPlusLogo} from '../assets/call-plus.svg';
import {ReactComponent as ClockLogo} from '../assets/clock.svg';
import {ReactComponent as DocumentLogo} from "../assets/document.svg";
import {ReactComponent as CheckListLogo} from "../assets/check-list.svg";
import BitrixUsersSelector from "../elements/inputs/BitrixUsersSelector";
import DefaultInput from "../elements/inputs/DefaultInput";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";


import getAPIClientMocked from "../hooks/apiClientMocked";
import CustomDatePicker from "../elements/inputs/CustomDatePicker";
import CheckListElement from "../elements/check_list/checkList";
import OneSelectUI from "../elements/inputs/one-select";


export default function MainPage({BX24}) {
  const [isLoading, setIsLoading] = useState(true)

  // Флаги, которые говорят что юзер что-то поменял после последнего получения данных
  const [somethingUpdatedFlag, setSomethingUpdatedFlag] = useState(false)

  const api = useMemo(() => getAPIClient(BX24), [])
  // const api = useMemo(() => getAPIClientMocked(), [])


  const [globalNotificationMessage, setGlobalNotificationMessage] = useState('')
  const [globalNotificationType, setGlobalNotificationType] = useState('error')

  const [inlineNotificationMessageMain, setInlineNotificationMessageMain] = useState('')
  const [inlineNotificationTypeMain, setInlineNotificationTypeMain] = useState('error')

  const [inlineNotificationMessageManualReport, setInlineNotificationMessageManualReport] = useState('')
  const [inlineNotificationTypeManualReport, setInlineNotificationTypeManualReport] = useState('error')

  const [currentSettings, setCurrentSettings] = useState()
  // Получение конфига, установка текущего СП
  useEffect(() => {
    api.get(`/bitrix_portals/settings`).then(response => {
        setCurrentSettings(response.data)
        setIsLoading(false)
    })
    // setCurrentSettings({
    //   b24_calls_responsible_name: 'asd',
    //   b24_calls_responsible_id: 'awd',
    //   calls_smart_process_id: 4,
    //   reports_smart_process_id: 3
    // })
    // setIsLoading(false)
  }, [])

  // Получение доступных смарт процессов
  const [smartProcessList, setSmartProcessList] = useState([])
  useEffect(() => {
    api.get(`/bitrix_portals/smart_process`).then(response => {
      setSmartProcessList(response.data)
      setIsLoading(false)
    })
    // setSmartProcessList([{
    //   name: 'Звонки',
    //   smart_process_id: 3
    // }, {
    //   name: 'Тест',
    //   smart_process_id: 4
    // }, {
    //   name: 'Звонки2',
    //   smart_process_id: 5
    // }])
  }, [])

  // Получение доступных числовых и строковых полей по выбранному смарт-процессу
  const [smartProcessFields, setSmartProcessFields] = useState([])
  useEffect(() => {
    if (!currentSettings?.calls_smart_process_id) {
      return
    }
    api.get(`/bitrix_portals/smart_process/fields?smart_process_id=${currentSettings.calls_smart_process_id}`).then(response => {
      setSmartProcessFields(response.data)
      setIsLoading(false)
    })
    // setSmartProcessFields([{
    //   field_type: 'int',
    //   name: 'testfield',
    //   system_name: "test213"
    // }, {
    //   field_type: 'string',
    //   name: 'testfie5ld',
    //   system_name: "test2131"
    // }, {
    //   field_type: 'string',
    //   name: 'testfie4ld',
    //   system_name: "123"
    // }, {
    //   field_type: 'float',
    //   name: 'testfie1ld',
    //   system_name: "asd123"
    // }, {
    //   field_type: 'float',
    //   name: 'testfield',
    //   system_name: "asdasda"
    // }, ])
  }, [currentSettings, smartProcessList])

  // Обновление конфигурации приложения (смарт-процесс, маппинги)
  const saveChanges = useCallback(async () => {
    let errorText = ''
    setGlobalNotificationMessage('')

    // отправка запрос на обновление settings
    if (somethingUpdatedFlag) {
      try {
        await api.post(`/bitrix_portals/settings`, currentSettings)
        setSomethingUpdatedFlag(false)
        setInlineNotificationTypeMain('success')
        setInlineNotificationMessageMain('Настройки обновлены')
      } catch (e) {
        setInlineNotificationTypeMain('error')
        setInlineNotificationMessageMain('Ошибка при обновлении настроек')
      }
    }
  }, [somethingUpdatedFlag, currentSettings])
  const [manualReportToDate, setManualReportToDate] = useState(new Date())
  const [manualReportFromDate, setManualReportFromDate] = useState(new Date())
  const makeManualReport = useCallback(async () => {
    setGlobalNotificationMessage('')
    if (!!manualReportFromDate) {
      try {
        await api.post('/reports/manual_report', {
          date_from: manualReportFromDate,
          date_to: manualReportToDate,
        })
        setInlineNotificationTypeManualReport('success')
        setInlineNotificationMessageManualReport('Запрос на формирование отчета отправлен. Через некоторое время ответственному придет уведомление')
      } catch (e) {
        setInlineNotificationTypeManualReport('error')
        setInlineNotificationMessageManualReport('Произошла ошибка при отправке запроса на формирование отчета')
      }
    }
  }, [manualReportFromDate, manualReportToDate])

  const [categories, setCategories] = useState([])
  const [selectedCheckCategory, setSelectedCheckCategory] = useState()
  useEffect(() => {
    api.get(`/check_lists/categories`).then(response => {
      setCategories(response.data)
      setSelectedCheckCategory(response.data[0])
      console.log('categories', response.data)
      setIsLoading(false)
    })
  }, [])
  const addCategory = useCallback(async (newCategory) => {
    try {
      const response = await api.post('/check_lists/categories', newCategory);
      setCategories(prev => [...prev, response.data]);
      setSelectedCheckCategory(response.data);
      setCheckListUpdatedFlag(true);
    } catch (error) {
      console.error('Failed to add category:', error);
      setGlobalNotificationType('error');
      setGlobalNotificationMessage('Ошибка при создании категории');
    }
  }, [api]);

  const deleteCategory = useCallback(async (categoryId) => {
    try {
      await api.delete(`/check_lists/categories?category_id=${categoryId}`);
      setCategories(prev => {
        const next = prev.filter(cat => cat.id !== categoryId);
        if (selectedCheckCategory?.id === categoryId) {
          setSelectedCheckCategory(next[0]);
        }
        return next;
      });
    } catch (error) {
      console.error('Failed to delete category:', error);
      setGlobalNotificationType('error');
      setGlobalNotificationMessage('Ошибка при удалении категории');
    }
  }, [api, selectedCheckCategory]);

  const editCategory = useCallback(async (categoryId, updatedData) => {
    try {
      await api.patch(`/check_lists/categories?category_id=${categoryId}`, updatedData);
      setCategories(prev => prev.map(cat =>
        cat.id === categoryId ? { ...cat, ...updatedData } : cat
      ));
      setSelectedCheckCategory(prev =>
        prev?.id === categoryId ? { ...prev, ...updatedData } : prev
      );
    } catch (error) {
      console.error('Failed to update category:', error);
      setGlobalNotificationType('error');
      setGlobalNotificationMessage('Ошибка при обновлении категории');
    }
  }, [api]);


  const [checkList, setCheckList] = useState([])
  const [checkListUpdatedFlag, setCheckListUpdatedFlag] = useState(false)
  useEffect( () => {
    if (!selectedCheckCategory) {
      return
    }
    api.get(`/check_lists?category_id=${selectedCheckCategory.id}`).then(response => {
      setCheckList(response.data)
      console.log('check_list', response.data)
      setIsLoading(false)
    })
    // setCheckList([{
    //   id: 1,
    //   name: 'Проверка',
    //   description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.',
    //   example: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.',
    //   mark_field_system_name: 'test1',
    //   comment_field_system_name: 'test11'
    // }, {
    //   id: 2,
    //   name: 'Проверка',
    //   description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.',
    //   example: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.',
    //   mark_field_system_name: 'test2',
    //   comment_field_system_name: 'test22'
    // }, {
    //   id: 3,
    //   name: 'Проверка',
    //   description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.',
    //   example: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.',
    //   mark_field_system_name: 'test3',
    //   comment_field_system_name: 'test11'
    // }])
    // setCheckListUpdatedFlag(false)
  }, [selectedCheckCategory])

  const saveCheckList = useCallback(() => {
    api.patch(`/check_lists?category_id=${selectedCheckCategory.id}`, {check_list: checkList}).then(response => {
      // подставляем реальные id с бэка (у новых элементов был временный id "new_...") —
      // иначе повторное сохранение того же элемента создаст дубликат вместо обновления
      setCheckList(response.data)
      setIsLoading(false)
    })
    setCheckListUpdatedFlag(false)
  }, [selectedCheckCategory, checkList])

  const [selectedMenuItem, setSelectedMenuItem] = useState('settings-calls') // settings, manual_report
  // isLoading сбрасывается пятью независимыми useEffect-ами (настройки, смарт-процессы,
  // поля СП, категории, чек-лист) — любой из них может отработать раньше остальных,
  // поэтому дополнительно ждём именно currentSettings, который рендер использует напрямую
  if (isLoading || !currentSettings) {
      return (
          <Loading isLoading={true}/>
      )
  }
  return (
    <>
      <Header/>
      <div className={s.main}>
        <InlineNotification
          type={globalNotificationType}
          text={globalNotificationMessage}
          hideFlag={globalNotificationMessage.length === 0}
        />
        <div className={s.main_container}>
          <div className={s.left_side_menu}>
            <div className={s.menu_list}>
              <div
                className={s.menu_item + ' ' + (selectedMenuItem === 'settings-calls' ? s.active_menu_item : '')}
                onClick={() => setSelectedMenuItem('settings-calls')}
              >
                <div className={s.menu_item_icon}><CallPlusLogo/></div>
                <div className={s.menu_item_text}>Настройки звонков</div>
              </div>
              {/*<div*/}
              {/*  className={s.menu_item + ' ' + (selectedMenuItem === 'settings-reports' ? s.active_menu_item : '')}*/}
              {/*  onClick={() => setSelectedMenuItem('settings-reports')}*/}
              {/*>*/}
              {/*  <div className={s.menu_item_icon}><ClockLogo/></div>*/}
              {/*  <div className={s.menu_item_text}>Настройки отчетов</div>*/}
              {/*</div>*/}
              <div
                className={s.menu_item + ' ' + (selectedMenuItem === 'check_list' ? s.active_menu_item : '')}
                onClick={() => setSelectedMenuItem('check_list')}
              >
                <div className={s.menu_item_icon}><CheckListLogo/></div>
                <div className={s.menu_item_text}>Чек лист</div>
              </div>
              {/*<div*/}
              {/*  className={s.menu_item + ' ' + (selectedMenuItem === 'manual_report' ? s.active_menu_item : '')}*/}
              {/*  onClick={() => setSelectedMenuItem('manual_report')}*/}
              {/*>*/}
              {/*  <div className={s.menu_item_icon}><DocumentLogo/></div>*/}
              {/*  <div className={s.menu_item_text}>Создание отчета</div>*/}
              {/*</div>*/}
            </div>
          </div>
          <div className={s.active_block}>
            {(selectedMenuItem === 'settings-calls') && <div className={s.settings}>
              <div className={s.settings_item}>
                <OneSelectUI
                  title={'Смарт процесс, куда будут складываться звонки'}
                  selectionOptions={smartProcessList.map(el => {return {value: el.smart_process_id, label: el.name}})}
                  selectedOption={smartProcessList.filter(el => el.smart_process_id === currentSettings.calls_smart_process_id).map(el => {return {value: el.smart_process_id, label: el.name}})[0]}
                  setSelectedOption={el => {
                    setSomethingUpdatedFlag(true)
                    const smartProcessChanged = currentSettings.calls_smart_process_id !== el?.value
                    currentSettings.calls_smart_process_id = el?.value
                    if (smartProcessChanged) {
                      currentSettings['b24_calls_category_field_system_name'] = undefined
                      currentSettings['b24_calls_overall_rating_field_system_name'] = undefined
                      currentSettings['b24_calls_link_field_system_name'] = undefined
                      currentSettings['b24_calls_duration_field_system_name'] = undefined
                    }
                    setCurrentSettings(JSON.parse(JSON.stringify(currentSettings)))
                  }}
                  placeholder={'Выберите...'}
                />
              </div>
              <div className={s.settings_item}>

                <BitrixUserSelector
                  title={'Ответственный в СП Звонки (уведомления по звонкам)'}
                  selectedUser={{
                    name: currentSettings.b24_calls_responsible_name,
                    id: currentSettings.b24_calls_responsible_id
                  }}
                  setSelectedUser={(user) => {
                    let tmp = JSON.parse(JSON.stringify(currentSettings));
                    tmp['b24_calls_responsible_id'] = user.id
                    tmp['b24_calls_responsible_name'] = user.name
                    setInlineNotificationMessageMain('')
                    setSomethingUpdatedFlag(true)
                    setCurrentSettings(tmp)
                  }}
                  BX24={BX24}
                />
              </div>
              <div className={s.settings_item}>
                <DefaultInput
                  title={'API-токен транскрибатора'}
                  value={currentSettings.transcribator_api_token}
                  onChangeFunction={(e) => {
                    let tmp = JSON.parse(JSON.stringify(currentSettings));
                    tmp['transcribator_api_token'] = e.target.value
                    setSomethingUpdatedFlag(true)
                    setInlineNotificationMessageMain('')
                    setCurrentSettings(tmp)
                  }}
                />
              </div>
              <div className={s.settings_item}>
                <DefaultInput
                  title={'Мин. длительность звонка, сек'}
                  value={currentSettings.min_call_duration_seconds}
                  onChangeFunction={(e) => {
                    let tmp = JSON.parse(JSON.stringify(currentSettings));
                    const digitsOnly = e.target.value.replace(/[^0-9]/g, "");
                    tmp['min_call_duration_seconds'] = digitsOnly === '' ? null : Number(digitsOnly)
                    setSomethingUpdatedFlag(true)
                    setInlineNotificationMessageMain('')
                    setCurrentSettings(tmp)
                  }}
                />
              </div>
              <div className={s.settings_item}>
                Настройки полей выбранного смарт-процесса
              </div>
              <div className={s.settings_item}>
                <OneSelectUI
                  title={'Категория звонка'}
                  isClearable={true}
                  selectionOptions={smartProcessFields.filter(el => el.field_type === 'string').map(el => {return {value: el.system_name, label: el.name}})}
                  selectedOption={smartProcessFields.filter(el => el.system_name === currentSettings.b24_calls_category_field_system_name).map(el => {return {value: el.system_name, label: el.name}})[0]}
                  setSelectedOption={el => {
                    let tmp = JSON.parse(JSON.stringify(currentSettings));
                    tmp['b24_calls_category_field_system_name'] = el?.value
                    setSomethingUpdatedFlag(true)
                    setInlineNotificationMessageMain('')
                    setCurrentSettings(tmp)
                  }}
                  placeholder={'Выберите...'}
                />
              </div>
              <div className={s.settings_item}>
                <OneSelectUI
                  title={'Общая оценка звонка'}
                  isClearable={true}
                  selectionOptions={smartProcessFields.filter(el => el.field_type === 'string' || el.field_type === 'double').map(el => {return {value: el.system_name, label: el.name}})}
                  selectedOption={smartProcessFields.filter(el => el.system_name === currentSettings.b24_calls_overall_rating_field_system_name).map(el => {return {value: el.system_name, label: el.name}})[0]}
                  setSelectedOption={el => {
                    let tmp = JSON.parse(JSON.stringify(currentSettings));
                    tmp['b24_calls_overall_rating_field_system_name'] = el?.value
                    setSomethingUpdatedFlag(true)
                    setInlineNotificationMessageMain('')
                    setCurrentSettings(tmp)
                  }}
                  placeholder={'Выберите...'}
                />
              </div>
              <div className={s.settings_item}>
                <OneSelectUI
                  title={'Ссылка на лид'}
                  isClearable={true}
                  selectionOptions={smartProcessFields.filter(el => el.field_type === 'string' || el.field_type === 'link').map(el => {return {value: el.system_name, label: el.name}})}
                  selectedOption={smartProcessFields.filter(el => el.system_name === currentSettings.b24_calls_link_field_system_name).map(el => {return {value: el.system_name, label: el.name}})[0]}
                  setSelectedOption={el => {
                    let tmp = JSON.parse(JSON.stringify(currentSettings));
                    tmp['b24_calls_link_field_system_name'] = el?.value
                    setSomethingUpdatedFlag(true)
                    setInlineNotificationMessageMain('')
                    setCurrentSettings(tmp)
                  }}
                  placeholder={'Выберите...'}
                />
              </div>
              <div className={s.settings_item}>
                <OneSelectUI
                  title={'Длительность звонка'}
                  isClearable={true}
                  selectionOptions={smartProcessFields.filter(el => el.field_type === 'string' || el.field_type === 'integer' || el.field_type === 'double').map(el => {return {value: el.system_name, label: el.name}})}
                  selectedOption={smartProcessFields.filter(el => el.system_name === currentSettings.b24_calls_duration_field_system_name).map(el => {return {value: el.system_name, label: el.name}})[0]}
                  setSelectedOption={el => {
                    let tmp = JSON.parse(JSON.stringify(currentSettings));
                    tmp['b24_calls_duration_field_system_name'] = el?.value
                    setSomethingUpdatedFlag(true)
                    setInlineNotificationMessageMain('')
                    setCurrentSettings(tmp)
                  }}
                  placeholder={'Выберите...'}
                />
              </div>
              <SubmitButton
                onClick={saveChanges}
                disabled={!somethingUpdatedFlag}
                className={s.submit}
                text={'Сохранить'}
              />
              <div className={s.settings_item}>
                <InlineNotification
                  type={inlineNotificationTypeMain}
                  text={inlineNotificationMessageMain}
                  hideFlag={!inlineNotificationMessageMain}
                />
              </div>
            </div>}
            {(selectedMenuItem === 'settings-reports') && <div className={s.settings}>
              <div className={s.settings_item}>
                <OneSelectUI
                  title={'Смарт процесс, куда будут складываться отчеты'}
                  selectionOptions={smartProcessList.map(el => {return {value: el.smart_process_id, label: el.name}})}
                  selectedOption={smartProcessList.filter(el => el.smart_process_id === currentSettings.reports_smart_process_id).map(el => {return {value: el.smart_process_id, label: el.name}})[0]}
                  setSelectedOption={el => {
                    setSomethingUpdatedFlag(true)
                    currentSettings.reports_smart_process_id = el?.value
                    setCurrentSettings(JSON.parse(JSON.stringify(currentSettings)))
                  }}
                  placeholder={'Выберите...'}
                />
              </div>
              <div className={s.settings_item}>
                <BitrixUserSelector
                  title={'Ответственный в СП Отчеты (уведомления по отчетам)'}
                  selectedUser={{
                    name: currentSettings.b24_reports_responsible_name,
                    id: currentSettings.b24_reports_responsible_id
                  }}
                  setSelectedUser={(user) => {
                    let tmp = JSON.parse(JSON.stringify(currentSettings));
                    tmp['b24_reports_responsible_id'] = user.id
                    tmp['b24_reports_responsible_name'] = user.name
                    setSomethingUpdatedFlag(true)
                    setInlineNotificationMessageMain('')
                    setCurrentSettings(tmp)
                  }}
                  BX24={BX24}
                />
              </div>
              <div className={s.settings_item}>
                <BitrixUsersSelector
                  title={'Наблюдатели в СП Отчеты'}
                  selectedUsers={currentSettings.b24_observers_responsible_users}
                  setSelectedUsers={(users) => {
                    console.log('users', users)
                    let tmp = JSON.parse(JSON.stringify(currentSettings));
                    tmp['b24_observers_responsible_users'] = users.map(u => {
                      return {
                        id: u.id,
                        name: u.name
                      }
                    })
                    setSomethingUpdatedFlag(true)
                    setInlineNotificationMessageMain('')
                    setCurrentSettings(tmp)
                  }}
                  BX24={BX24}
                />
              </div>
              <div className={s.settings_item}>
                <DefaultInput
                  title={'Периодичность создания отчета (в секундах)'}
                  value={currentSettings.update_interval}
                  onChangeFunction={(e) => {
                    let tmp = JSON.parse(JSON.stringify(currentSettings));
                    tmp['update_interval'] = e.target.value.replace(/[^0-9]/g, "");
                    setSomethingUpdatedFlag(true)
                    setInlineNotificationMessageMain('')
                    setCurrentSettings(tmp)
                  }}
                />
              </div>
              <div className={s.settings_item}>
                <DefaultInput
                  title={'Максимум звонков в отчете'}
                  value={currentSettings.limit_of_calls_in_report}
                  onChangeFunction={(e) => {
                    let tmp = JSON.parse(JSON.stringify(currentSettings));
                    tmp['limit_of_calls_in_report'] = e.target.value.replace(/[^0-9]/g, "");
                    setSomethingUpdatedFlag(true)
                    setInlineNotificationMessageMain('')
                    setCurrentSettings(tmp)
                  }}
                />
              </div>
              <SubmitButton
                onClick={saveChanges}
                disabled={!somethingUpdatedFlag}
                className={s.submit}
                text={'Сохранить'}
              />
              <div className={s.settings_item}>
                <InlineNotification
                  type={inlineNotificationTypeMain}
                  text={inlineNotificationMessageMain}
                  hideFlag={!inlineNotificationMessageMain}
                />
              </div>
            </div>}

            {(selectedMenuItem === 'manual_report' && <div className={s.settings}>

              <div className={s.settings_item}>
                <CustomDatePicker
                  title={'Начало отчетного периода'}
                  value={manualReportFromDate}
                  onChangeFunction={(date) => {
                    setManualReportFromDate(date)
                    setInlineNotificationMessageManualReport('')
                  }}
                />
              </div>
              <div className={s.settings_item}>
                <CustomDatePicker
                  title={'Конец отчетного периода'}
                  value={manualReportToDate}
                  onChangeFunction={(date) => {
                    setManualReportToDate(date)
                    setInlineNotificationMessageManualReport('')
                  }}
                />
              </div>
              <div className={s.settings_item}>
                <SubmitButton
                  onClick={makeManualReport}
                  className={s.submit}
                  disabled={!manualReportFromDate || !manualReportToDate}
                  text={'Сделать отчет'}
                />
              </div>
              <InlineNotification
                type={inlineNotificationTypeManualReport}
                text={inlineNotificationMessageManualReport}
                hideFlag={!inlineNotificationMessageManualReport}
              />
            </div>)}
            {(selectedMenuItem === 'check_list' && somethingUpdatedFlag) && <>
              <div className={s.settings_item}>
                <InlineNotification
                  type={'error'}
                  text={'Для редактирования чек-листов сохраните отредактированные настройки в других пунктах меню'}
                  hideFlag={false}
                />
              </div>
            </>}
            {(selectedMenuItem === 'check_list' && !currentSettings.calls_smart_process_id) && <>
              <div className={s.settings_item}>
                <InlineNotification
                  type={'error'}
                  text={'Для редактирования чек-листов укажите смарт процесс со звонками'}
                  hideFlag={false}
                />
              </div>
            </>}
            {(selectedMenuItem === 'check_list' && !somethingUpdatedFlag && currentSettings.calls_smart_process_id && !selectedCheckCategory) && <>
              <div className={s.settings_item}>
                <InlineNotification
                  type={'error'}
                  text={'Создайте хотя бы одну категорию чек-листа'}
                  hideFlag={false}
                />
              </div>
            </>}
            {((selectedMenuItem === 'check_list' && !somethingUpdatedFlag && currentSettings.calls_smart_process_id && selectedCheckCategory) && <>
              <CheckListElement
                checkList={checkList}
                setCheckList={(v) => {
                  setCheckListUpdatedFlag(true)
                  console.log('123123123123', v)
                  setCheckList(v)
                }}
                availableB24Fields={smartProcessFields}
                saveDisabledFlag={!checkListUpdatedFlag}
                saveFunc={saveCheckList}
                categoriesList={categories}
                selectedCategory={selectedCheckCategory}
                setSelectedCategory={setSelectedCheckCategory}
                editCategoryFunc={editCategory}
                addCategoryFunc={addCategory}
                deleteCategoryFunc={deleteCategory}
              />
              <InlineNotification
                type={inlineNotificationTypeManualReport}
                text={inlineNotificationMessageManualReport}
                hideFlag={!inlineNotificationMessageManualReport}
              />
            </>)}

          </div>
        </div>
      </div>
    </>
  )
}